import { createPortal } from 'react-dom';

export function LoadingWrapper({ containerRef, children }) {
  if (containerRef) {
    return createPortal(children, containerRef);
  }
  return null;
}
